import XDate from 'xdate';
import Fetch from './fetch';

const EcommerceApi = {
  addToCart: (orderItems) => Fetch.post('add_to_cart/', { order_items: orderItems }),
  approveRefundRequests: (academyId, refundRequestIds) =>
    Fetch.put('academy_orders/approve_refund_requests', {
      academy_id: academyId,
      refund_request_ids: refundRequestIds,
    }),
  denyRefundRequests: (academyId, refundRequestIds) =>
    Fetch.put('academy_orders/deny_refund_requests', {
      academy_id: academyId,
      refund_request_ids: refundRequestIds,
    }),
  fetchCart: () => Fetch.get('cart'),
  fetchAcademyOrders: (academyId) => Fetch.get(`academy_orders/${academyId}`),
  fetchAcademyOrderRefundRequests: (academyId) => Fetch.get(`academy_orders/${academyId}/pending_refund_requests`),
  fetchAcademyOrderPaymentStatus: (orderId) => Fetch.get(`payment_status/${orderId}`),
  removeFromCart: (orderItems) => Fetch.delete('remove_from_cart/', { order_items: orderItems }),
  createGuestCart: (orderItems) => Fetch.post('create_guest_cart', { order_items: orderItems }),
  requestOrderItemRefund: (orderItemId) => Fetch.post('request_order_item_refund', { order_item_id: orderItemId }),
  cancelRequestOrderItemRefund: (orderItemId) =>
    Fetch.delete('cancel_request_order_item_refund', { order_item_id: orderItemId }),
  createPromo: (academyId, promoTitle) => Fetch.post(`academies/${academyId}/promos`, { promo_title: promoTitle }),
  applyPromoToOrder: (orderId, promoCode) =>
    Fetch.put(`apply_promo_to_order/${orderId}`, {
      promo_code_name: promoCode,
      users_current_date: new XDate().toString('yyyy-MM-dd'),
    }),
  removePromoFromOrder: (orderId) => Fetch.delete(`remove_promo_from_order/${orderId}`),
  updatePromo: (promoId, data) => Fetch.put(`promos/${promoId}`, data),
  deletePromo: (promoId) => Fetch.delete(`promos/${promoId}`),
  createPromoCode: (promoId, codeName) =>
    Fetch.post(`promos/${promoId}/promo_codes`, { promo_id: promoId, code_name: codeName }),
  deletePromoCode: (promoCodeId) => Fetch.delete(`promo_codes/${promoCodeId}`),
  createPromoContents: (promoId, promoContents) =>
    Fetch.post(`promos/${promoId}/promo_contents`, {
      promo_id: promoId,
      promo_contents_params: promoContents,
    }),
  deletePromoContents: (promoId, promoContentIds) =>
    Fetch.delete(`promos/${promoId}/promo_contents`, { promo_content_ids: promoContentIds }),
  fetchAcademyCollectionAndCertContent: (academyId) => Fetch.get(`academies/${academyId}/contents`),
  validateFreeOrder: (orderId) => Fetch.put(`validate_free_order/${orderId}`),
};
export default EcommerceApi;
